export const constQuestionList = [
  {
    index: 0,
    category: '账号与登录',
    list: [
      {
        question: '什么是喵呜账号？',
        content: '喵呜账号是您使用喵呜软件服务的重要入口。注册账号后，您将能够登录并使用喵呜app和官网服务，享受多种功能，如生成AI名片、录入私有知识库、使用AI名片帮助您销售等。'
      },
      {
        question: '如何注册喵呜账号？',
        content: '由于我们提供的商业AI名片服务为付费项目，您需要先购买注册码。获取注册码后，在app端点击“马上注册”，依次输入手机号、短信验证码和注册码即可完成注册。'
      },
      {
        question: '注册码怎么获取？',
        content: '- 个人用户：请联系您所在地区的代理商购买。<br>' +
          '- 大量需求用户：请直接联系我们的商务经理咨询。<br>' +
          '联系方式见官网-帮助中心-商务合作页面。'
      },
      {
        question: '是否支持多端同时在线？',
        content: '喵呜现仅支持app及pc端同时各在线一个设备。'
      },
      {
        question: '昵称是否可以修改？',
        content: '您可以在知识库管理中修改昵称。'
      },
      {
        question: '头像怎么修改？',
        content: '账号头像使用的是您生成的数字人形象。若需修改，请重新生成数字人形象。目前不支持单独修改头像。'
      }
    ]
  },
  {
    index: 1,
    category: '创建形象',
    list: [
      {
        question: '如何创建形象？',
        content: '您可以在App主页点击编辑形象，选择合适的模版后上传您的照片，稍等1-2分钟即可获得根据模板生成的AI名片，效果生动自然。'
      },
      {
        question: '我对我的形象不满意怎么办？',
        content: '若您对形象不满意，重新选择模板生成即可。'
      }
    ]
  },
  {
    index: 2,
    category: '知识库',
    list: [
      {
        question: '什么是知识库？',
        content: '知识库是您AI名片的“大脑”，录入您的专有知识后，AI名片可以像您一样思考，帮助您完成产品销售。'
      },
      {
        question: '知识库怎么填写？有模版吗？',
        content: '知识库分为三个主要部分：个人基础信息、服务信息、产品管理。<br>' +
          '1. 个人基础信息<br>' +
          '这部分是关于您AI名片的人物设定，包括性格、爱好、标签、组织信息等。性格偏好是定义了您的AI名片的说话风格。为了让用户更全面了解您，您可以添加自己的网店、官网或个人主页的链接。' +
          '请确保链接以http开头，以便正确跳转。建议在添加前在浏览器中测试链接的有效性。需要注意的是，由于微信浏览器的风控政策，淘宝链接有时在微信中无法打开。<br>' +
          '此外您还可以上传您的人设视频，方便用户在您的数字分身页面快速了解您。<br>' +
          '2. 服务信息管理<br>' +
          '这部分内容应与您的业务紧密相关。您可以按照各模块具体内容要求自行填写或使用AI辅助生成填写。<br>' +
          '3. 产品管理<br>' +
          '在产品部分，建议详细录入您的产品相关信息，如产品的颜色、型号、尺寸等。若您有营业执照，可申请入驻商城，通过商城上架和管理您的产品，<br>' +
          '用户可直接通过数字分身完成交易。请注意：非商城上架的商品无法在数字分身直接完成交易，您需在知识库中录入明确的交易方式。<br>' +
          '知识库支持多次编辑和更新。请避免使用过多华丽辞藻，保持信息的准确性和实用性。'
      }
    ]
  },
  {
    index: 3,
    category: '分享',
    list: [
      {
        question: '怎么把我的AI名片发给别人？',
        content: '分享是你的用户与你快速建立连接的方式。'
      },
      {
        question: '怎么分享？',
        content: '主页右上角点击分享按钮可通过分享小程序、h5以及链接的形式快速完成分享。小程序可直接分享给微信好友；h5可分享至微信好友及朋友圈\n' +
          '若想要宣传您的产品/活动/观点/业务等，可以通过营销工具生成相应海报或名片后分享。\n' +
          '你的用户可以点开你分享的链接或者识别图片中的二维码进入您的小程序主页与你的AI名片对话。注：喵呜官方小程序为：喵呜AI名片'
      }
    ]
  },
  {
    index: 4,
    category: '商城',
    list: [
      {
        question: '如何入驻商城？',
        content: '您可从官网我的商城入口进行申请'
      },
      {
        question: '申请入驻商城有什么条件？要提供什么材料吗？',
        content: '入驻商城现仅对有营业执照商家开放。<br>' +
          '需提供材料如下：<br>' +
          '1、营业执照电子版/拍照；<br>' +
          '2、法人身份证正反面照片；<br>' +
          '3、店铺结算账户信息。'
      },
      {
        question: '我申请了入驻商城怎么还没通过？',
        content: '入驻商城审核时间为1-2个工作日， 请耐心等待。若超过2个工作日仍无审核结果，请联系您的代理进行反馈。'
      },
      {
        question: '商城入驻支持哪些品类？',
        content: '商城支持品类随审核要求会有所变动，当前（20240627）支持品类如下：\n'
      }
    ]
  },
  {
    index: 5,
    category: '代理与分销',
    list: [
      {
        question: '如何成为代理？',
        content: '联系我们的商务经理李凯。手机号码：13770732882 邮箱：363185744@qq.com'
      },
      {
        question: '代理规则是怎样的',
        content: '- 黄金代理：100个AI名片，正式代理合同，颁发黄金代理证书。<br>' +
          '- 钻石代理：1000个AI名片，正式代理合同，颁发钻石代理证书，免费参与喵呜AI名片链动2+1平台。<br>' +
          '- 荣耀代理：3000个AI名片，正式代理合同，颁发荣耀代理证书，管理独立链动2+1平台，发展下级代理，半年保底服务，运营商种子服务。'
      },
      {
        question: '分销模式是怎样的',
        content: '我们的分销模式为链动2+1模式，是裂变速度最快，个人收益最高的一种分销模式。详细规则咨询代理商。'
      }
    ]
  },
  {
    index: 6,
    category: '其他',
    list: [
      {
        question: '什么是喵币？有什么用？',
        content: '喵币是app内虚拟货币，可用于生成形象、创建知识库和对话等。喵币不支持转移或交易。'
      },
      {
        question: '怎么看喵币花哪儿了？',
        content: '喵币数量可在app端-我的 中查看。点击余额，点击右上角“明细”即可查看喵币消耗情况。'
      },
      {
        question: '会员有什么用？',
        content: '为确保您能持续享受我们的服务，避免因喵币消耗过快而面临用户服务中断的风险，我们推出喵呜会员服务。加入后，您将解锁以下特权：<br>' +
          '- 无限形象生成：免费不限次数，随时创建多样化的数字形象。<br>' +
          '- 专属知识库训练：不限次数地训练和更新您的个人知识库，使其更聪明、更个性化。<br>' +
          '- 免费对话：通过喵呜链接及小程序与您的AI名片互动，无需担心喵币消耗。<br>' +
          '- 免费使用营销工具：无限次快速根据知识库生成营销获客海报和文案。'
      },
      {
        question: '你们有客服邮箱吗？',
        content: '您有任何产品和服务上的问题或建议，都可反馈至我们的客服邮箱 service@meupop.com'
      }
    ]
  }
]

export const constShopCategory = []



// WEBPACK FOOTER //
// ./src/utils/constant.js